import React from 'react';
const RequestTabsComponent = ({ activeTab, tabs, onRequestTabClick }) => {
  return (
    // <div className="border-b border-gray-300 mt-6 mb-4">
    //   <nav className="flex space-x-4 overflow-x-auto">
    //     {tabs.map(tab => (
    //       <button
    //         key={tab.menuItem}
    //         onClick={() => onRequestTabClick(tab.menuItem)}
    //         className={`py-2 px-4 whitespace-nowrap font-medium ${
    //           activeTab === tab.menuitem ? 'border-b-2 border-blue-600 text-black-600' : 'text-gray-600 hover:text-black-600'
    //         }`}
    //         type="button"
    //       >
    //         {tab.menuItem}
    //       </button>
    //     ))}
    //   </nav>
    // </div>
    <div className="mt-6 mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">More details...</label>
      <div className="relative w-full">
        <select
          className="block w-full px-4 py-2 pr-8 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 appearance-none"
          value={activeTab || ''}
          onChange={e => onRequestTabClick(e.target.value)}
        >
          {tabs.map(tab => (
            <option key={tab.menuItem} value={tab.menuItem}>
              {tab.menuItem}
            </option>
          ))}
        </select>
        {/* Flecha personalizada */}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default RequestTabsComponent;
